<p [innerHTML]="extraData['text']"></p>
